import { useState } from 'react';

const POR_PAGINA = 20;

export function usePaginacao(items, porPagina = POR_PAGINA) {
  const [pagina, setPagina] = useState(1);

  const total = items.length;
  const totalPaginas = Math.ceil(total / porPagina);
  const inicio = (pagina - 1) * porPagina;
  const paginados = items.slice(inicio, inicio + porPagina);

  const irPara = (p) => setPagina(Math.min(Math.max(1, p), totalPaginas || 1));

  function Paginacao() {
    if (totalPaginas <= 1) return null;
    const pages = [];
    for (let i = 1; i <= totalPaginas; i++) pages.push(i);
    return (
      <nav className="d-flex align-items-center justify-content-between mt-3">
        <span style={{ fontSize: 13, color: 'var(--cjc-gray-400)' }}>
          {inicio + 1}–{Math.min(inicio + porPagina, total)} de {total}
        </span>
        <ul className="pagination pagination-sm mb-0">
          <li className={`page-item${pagina === 1 ? ' disabled' : ''}`}>
            <button className="page-link" onClick={() => irPara(pagina - 1)}>‹</button>
          </li>
          {pages.map(p => (
            <li key={p} className={`page-item${p === pagina ? ' active' : ''}`}>
              <button className="page-link" onClick={() => irPara(p)}>{p}</button>
            </li>
          ))}
          <li className={`page-item${pagina === totalPaginas ? ' disabled' : ''}`}>
            <button className="page-link" onClick={() => irPara(pagina + 1)}>›</button>
          </li>
        </ul>
      </nav>
    );
  }

  return { paginados, Paginacao, pagina, irPara };
}
